import { useEffect, useState, useRef, useCallback } from 'react';

function useHorizontalScroll(elementRef, windowSize) {
  const debounceTimer = useRef();

  const [hasRightScroll, setHasRightScroll] = useState(false);
  const [hasLeftScroll, setHasLeftScroll] = useState(false);

  const handleScrollIndicators = useCallback(
    function () {
      const element = elementRef.current.children[0];
      clearTimeout(debounceTimer.current);
      debounceTimer.current = setTimeout(() => {
        const scrollOffset = element.scrollWidth - element.clientWidth;
        const scrollLeft = element.scrollLeft;
        setHasRightScroll(scrollOffset - scrollLeft > 0);
        setHasLeftScroll(scrollLeft > 0);
      }, 250);
    },
    [elementRef],
  );

  useEffect(() => {
    handleScrollIndicators();
    const element = elementRef.current.children[0];
    element.addEventListener('scroll', handleScrollIndicators);
    return () => {
      element.removeEventListener('scroll', handleScrollIndicators);
    };
  }, [handleScrollIndicators, elementRef]);

  useEffect(() => {
    handleScrollIndicators();
  }, [handleScrollIndicators, windowSize]);

  return [hasLeftScroll, hasRightScroll];
}

export default useHorizontalScroll;
